/** Texto legible de garaje_tipos (Abierto, Cerrado, Cubierto, Interior, Exterior). */
export function garajeTiposTexto(raw) {
  const keys = Array.isArray(raw)
    ? raw.map((x) => String(x).toLowerCase())
    : String(raw || "")
        .split(",")
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);
  if (!keys.length) return null;
  const map = { abierto: "Abierto", cerrado: "Cerrado", cubierto: "Cubierto", interior: "Interior", exterior: "Exterior" };
  return keys.map((k) => map[k] || k.charAt(0).toUpperCase() + k.slice(1)).join(", ");
}

function pick(d, p, key) {
  const a = d?.[key];
  const b = p?.[key];
  if (a !== undefined && a !== null && a !== "") return a;
  if (b !== undefined && b !== null && b !== "") return b;
  return null;
}

function flagOn(d, p, key) {
  if (d?.[key] || p?.[key]) return true;
  // Ampliar: tipo en *_id cuenta aunque el bool haya quedado false
  if (key === "eq_aire" || key === "eq_calefaccion") {
    const id = pick(d, p, `${key}_id`);
    return id != null && id !== "";
  }
  return false;
}

function joinPartes(parts) {
  const limpias = parts.filter((x) => x != null && String(x).trim() !== "");
  return limpias.length ? limpias.map((x) => String(x).trim()).join(" · ") : null;
}

/**
 * Subtexto bajo el chip verde de equipamiento (sin título).
 * @param {string} eqKey — p. ej. eq_garaje, eq_calefaccion
 */
export function equipamientoSubtexto(eqKey, d, p) {
  if (!flagOn(d, p, eqKey)) return null;

  switch (eqKey) {
    case "eq_garaje": {
      const plazas = pick(d, p, "num_plazas_garaje") ?? pick(d, p, "num_garajes");
      const plazasTxt =
        plazas != null && plazas !== ""
          ? `${plazas} plaza${Number(plazas) === 1 ? "" : "s"}`
          : null;
      return joinPartes([
        plazasTxt,
        garajeTiposTexto(pick(d, p, "garaje_tipos")),
        pick(d, p, "num_garaje"),
        pick(d, p, "eq_garaje_obs"),
      ]);
    }
    case "eq_trastero":
      return joinPartes([pick(d, p, "num_trastero"), pick(d, p, "eq_trastero_obs")]);
    case "eq_calefaccion":
      return joinPartes([pick(d, p, "calefaccion_tipo_nombre"), pick(d, p, "eq_calefaccion_obs")]);
    case "eq_aire":
      return joinPartes([pick(d, p, "aire_tipo_nombre"), pick(d, p, "eq_aire_obs")]);
    case "eq_piscina_priv":
      return joinPartes([pick(d, p, "piscina_priv_tipo_nombre"), pick(d, p, "eq_piscina_priv_obs")]);
    case "eq_piscina_comun":
      return joinPartes([pick(d, p, "piscina_comun_tipo_nombre"), pick(d, p, "eq_piscina_comun_obs")]);
    default:
      return null;
  }
}

/** ¿Algún equipamiento activo tiene subtexto? */
export function hayEquipamientoSubtexto(d, p, eqKeys) {
  return eqKeys.some((k) => equipamientoSubtexto(k, d, p));
}
